import InsightPie from "./InsightPie";
import ScorecardInfoTip from "./ScorecardInfoTip";
import { fmtNum, fmtMoneyShort } from "./formatters";

/**
 * Sales composition pie (by showroom or by model). Data shape:
 *   `[{ key, count, amount }]`
 * The legend shows unit count + percentage + monetary amount so exec users
 * can eyeball value-mix at a glance. Non-interactive (no `onSelect`).
 */
export default function SalesPieChart({ title, subtitle, data, testId }) {
  const items = (data || []).filter((d) => (d.count || 0) > 0);
  const total = items.reduce((s, d) => s + (d.count || 0), 0);

  const isShowroom = testId === "sales-by-showroom";

  return (
    <InsightPie
      testId={testId}
      title={title}
      subtitle={`${fmtNum(total)} unidades · ${subtitle}`}
      header={
        <ScorecardInfoTip
          label={title}
          formula={isShowroom
            ? "count(sales) agrupado por sales.showroom · Σ valor_neto por sucursal"
            : "count(sales) agrupado por sales.model · Σ valor_neto por modelo"}
          extra={isShowroom
            ? "Sucursal = showroom en la factura de venta."
            : "Modelo tal como se registra en la venta (mayúsculas)."}
          source={isShowroom ? "sales.showroom" : "sales.model"}
        />
      }
      data={items}
      getKey={(d) => d.key}
      getValue={(d) => d.count || 0}
      centerValue={fmtNum(total)}
      centerLabel="UNIDADES"
      emptyMessage="Sin ventas en el período seleccionado."
      legendMaxHeight={220}
      renderLegendRow={({ item, color, key, index, total: t, isHover, onEnter, onLeave }) => {
        const pct = ((item.count / t) * 100).toFixed(1);
        return (
          <div key={key}
            className="flex items-center justify-between py-1.5 px-2 rounded gap-2"
            onMouseEnter={onEnter}
            onMouseLeave={onLeave}
            data-testid={`${testId}-row-${index}`}
            style={{ cursor: "default", background: isHover ? "#f8fafc" : "transparent" }}
          >
            <div className="flex items-center gap-2 text-xs min-w-0 flex-1">
              <span style={{ width: 10, height: 10, borderRadius: 2, background: color, display: "inline-block", flexShrink: 0 }} />
              <span className="font-bold text-gray-900 truncate" title={item.key}>{item.key}</span>
            </div>
            <div className="text-xs font-bold tabular-nums text-right flex-shrink-0">
              <div className="text-gray-900">
                {fmtNum(item.count)}u <span className="text-gray-400">({pct}%)</span>
              </div>
              <div className="text-[10px] text-gray-500 font-semibold">{fmtMoneyShort(item.amount)}</div>
            </div>
          </div>
        );
      }}
    />
  );
}
